import { useQuery } from '@tanstack/react-query';

type Installation = {
  id: string;
  installationId: number;
  accountId?: number;
  accountLogin: string;
  accountType: string;
  htmlUrl: string;
  avatarUrl: string | null;
  installedBy: string;
  stripeSubscriptionId: string | null;
  stripeCustomerId: string | null;
  stripeAutomaticallyAssignAndRemoveSeats: boolean;
  stripeAutomaticallyAddSeatsOnUsageLimit: boolean;
  flexCapacityEnabled: boolean;
  flexCapacityMaxCentsPerPeriod: number | null;
  flexCapacityTopUpLines: number;
  createdAt: string;
};

async function fetchInstallation(
  installationId: number,
  signal?: AbortSignal,
): Promise<Installation> {
  const response = await fetch(`/api/installations/${installationId}`, { signal });
  if (!response.ok) {
    throw new Error('Failed to fetch installation');
  }
  return response.json();
}

export function useInstallation(installationId: number | undefined) {
  return useQuery({
    queryKey: ['installation', installationId],
    queryFn: ({ signal }) => fetchInstallation(installationId!, signal),
    enabled: !!installationId,
  });
}
